module.exports = __webpack_public_path__ + "img/description-img.29cff976.png";